// Verificações de compatibilidade para evitar tela em branco
export const checkBrowserCompatibility = () => {
  const errors = [];
  
  // Verifica se o navegador suporta ES6+
  try {
    // Testa arrow functions
    const testArrow = () => true;
    if (typeof testArrow !== 'function') {
      errors.push('Arrow functions não suportadas');
    }
    
    // Testa let/const
    let testLet = 1;
    const testConst = 2;
    if (testLet !== 1 || testConst !== 2) {
      errors.push('let/const não suportados');
    }
    
    // Testa destructuring
    const { test } = { test: true };
    if (!test) {
      errors.push('Destructuring não suportado');
    }
    
    // Testa template literals
    const testTemplate = `test ${1}`;
    if (testTemplate !== 'test 1') {
      errors.push('Template literals não suportados');
    }
    
    // Testa Promise
    if (typeof Promise === 'undefined') {
      errors.push('Promises não suportadas');
    }
    
    // Testa fetch
    if (typeof fetch === 'undefined') {
      errors.push('Fetch API não suportada');
    }
    
    // Testa Symbol
    if (typeof Symbol === 'undefined') {
      errors.push('Symbol não suportado');
    }
    
    // Testa Map/Set
    if (typeof Map === 'undefined' || typeof Set === 'undefined') {
      errors.push('Map/Set não suportados');
    }
    
  } catch (error) {
    errors.push(`Erro geral de compatibilidade: ${error.message}`);
  }
  
  return errors;
};

export const checkDOMElements = () => {
  const errors = [];
  
  // Verifica se o elemento root existe
  const root = document.getElementById('root');
  if (!root) {
    errors.push('Elemento #root não encontrado');
  }
  
  // Verifica se document.body existe
  if (!document.body) {
    errors.push('document.body não encontrado');
  }
  
  return errors;
};

export const logBrowserInfo = () => {
  const info = {
    userAgent: navigator.userAgent,
    vendor: navigator.vendor,
    platform: navigator.platform,
    language: navigator.language,
    cookieEnabled: navigator.cookieEnabled,
    onLine: navigator.onLine,
    windowLocation: window.location.href,
    windowSize: {
      width: window.innerWidth,
      height: window.innerHeight
    },
    screenSize: {
      width: window.screen?.width || 'unknown',
      height: window.screen?.height || 'unknown'
    },
    timestamp: new Date().toISOString()
  };
  
  console.group('🔍 Informações do Navegador');
  console.table(info);
  console.groupEnd();
  
  return info;
};

export const handleCriticalError = (error, errorInfo = null) => {
  console.error('❌ Erro crítico detectado:', error);
  if (errorInfo) {
    console.error('📍 Informações adicionais:', errorInfo);
  }
  
  // Log das informações do navegador
  logBrowserInfo();
  
  // Verifica compatibilidade
  const compatibilityErrors = checkBrowserCompatibility();
  if (compatibilityErrors.length > 0) {
    console.error('❌ Problemas de compatibilidade:', compatibilityErrors);
  }
  
  // Verifica DOM
  const domErrors = checkDOMElements();
  if (domErrors.length > 0) {
    console.error('❌ Problemas de DOM:', domErrors);
  }
  
  // Fallback para tela de erro
  const errorHtml = `
    <div style="
      min-height: 100vh;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 20px;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
      color: #333;
      text-align: center;
    ">
      <div style="
        background: white;
        padding: 40px;
        border-radius: 12px;
        box-shadow: 0 10px 30px rgba(0,0,0,0.1);
        max-width: 500px;
        width: 100%;
      ">
        <div style="font-size: 60px; margin-bottom: 20px;">⚠️</div>
        <h1 style="margin: 0 0 15px 0; color: #e74c3c; font-size: 24px;">
          Erro no Sistema de Pagamento
        </h1>
        <p style="margin: 0 0 20px 0; color: #666; line-height: 1.5;">
          Ocorreu um problema inesperado. Nossa equipe foi notificada.
        </p>
        <div style="margin: 20px 0;">
          <button onclick="window.location.reload()" style="
            background: #3498db;
            color: white;
            border: none;
            padding: 12px 24px;
            border-radius: 6px;
            cursor: pointer;
            font-size: 16px;
            margin: 0 10px;
            transition: background 0.3s;
          " onmouseover="this.style.background='#2980b9'" onmouseout="this.style.background='#3498db'">
            🔄 Recarregar Página
          </button>
          <button onclick="window.location.href='https://sharmaq.com.br'" style="
            background: #95a5a6;
            color: white;
            border: none;
            padding: 12px 24px;
            border-radius: 6px;
            cursor: pointer;
            font-size: 16px;
            margin: 0 10px;
            transition: background 0.3s;
          " onmouseover="this.style.background='#7f8c8d'" onmouseout="this.style.background='#95a5a6'">
            🏠 Voltar ao Site
          </button>
        </div>
        <details style="margin-top: 20px; text-align: left;">
          <summary style="cursor: pointer; color: #666; font-size: 14px;">
            Detalhes técnicos
          </summary>
          <pre style="
            background: #f8f9fa;
            padding: 15px;
            border-radius: 6px;
            font-size: 12px;
            overflow: auto;
            margin-top: 10px;
            border: 1px solid #e9ecef;
            color: #666;
          ">${error.toString()}${errorInfo ? '\n\nStack:\n' + errorInfo : ''}</pre>
        </details>
      </div>
    </div>
  `;
  
  // Só modifica o DOM se necessário
  if (document.body && !document.querySelector('[data-error-boundary]')) {
    document.body.innerHTML = errorHtml;
    document.body.setAttribute('data-error-boundary', 'true');
  }
};
